import { Box } from '@mui/material';
import { EmojiEvents, ShoppingCart, TrendingUp } from '@mui/icons-material';
import {
  DqStatCard,
  SectionTitle,
  STAT_CARD_GRID_4_SX,
  STAT_CARD_GRID_STREAKS_SX,
} from './dqShared';

const STREAK_MILESTONE_CARDS = [
  { key: 'streakGte3', label: 'Streak ≥ 3', valueColor: '#1546B9' },
  { key: 'streakGte15', label: 'Streak ≥ 15', valueColor: '#0066FF' },
  { key: 'streakGte30', label: 'Streak ≥ 30', valueColor: '#00ABAE' },
  { key: 'streakGte90', label: 'Streak ≥ 90', valueColor: '#00AE37' },
  { key: 'streakGte365', label: 'Streak ≥ 365', valueColor: '#8F0177' },
];

const DqOverviewSection = ({ overview }) => {
  if (!overview) return null;

  const totalDqUsers = overview.totalDqUsers ?? 0;
  const loggedInUsers = overview.loggedInUsers ?? 0;
  const dqSubscribed = overview.dqSubscribedCount ?? 0;

  return (
    <>
      <SectionTitle>Overview</SectionTitle>
      <Box sx={{ ...STAT_CARD_GRID_4_SX, mb: 2 }}>
        <Box sx={{ gridColumn: { xs: '1 / -1', lg: 'span 2' } }}>
          <DqStatCard
            title="Daily Question adoption"
            value={`${overview.adoptionRate ?? 0}%`}
            subtitle={`${totalDqUsers.toLocaleString()} of ${loggedInUsers.toLocaleString()} logged-in users have answered at least one daily question.`}
            icon={<TrendingUp sx={{ color: 'success.main' }} />}
            valueColor="success.main"
          />
        </Box>
        <Box sx={{ gridColumn: { xs: '1 / -1', lg: 'span 2' } }}>
          <DqStatCard
            title="Subscribed among Daily Question users"
            value={`${overview.dqSubscriptionRate ?? 0}%`}
            subtitle={`${dqSubscribed.toLocaleString()} of ${totalDqUsers.toLocaleString()} users who answered at least one daily question are subscribed.`}
            icon={<ShoppingCart sx={{ color: 'primary.main' }} />}
            valueColor="primary.main"
          />
        </Box>
      </Box>

      <Box sx={STAT_CARD_GRID_STREAKS_SX}>
        {STREAK_MILESTONE_CARDS.map((milestone) => (
          <DqStatCard
            key={milestone.key}
            title={milestone.label}
            value={overview[milestone.key] ?? 0}
            icon={<EmojiEvents sx={{ color: milestone.valueColor }} />}
            valueColor={milestone.valueColor}
          />
        ))}
      </Box>
    </>
  );
};

export default DqOverviewSection;
